import { Link } from "gatsby";
import React, { useState } from "react";
import { useTranslation } from "../../contexts/TranslationContext";
import MobileNavbar from "./MobileNavbar";
import IftarKnowledgeChallengeBanner from "@/components/layout/IftarKnowledgeChallengeBanner";

export type NavItem = {
  name: string;
  path?: string;
  dropdown?: NavItem[];
  noLangPrefix?: boolean;
};

const LINKS: NavItem[] = [
  { name: "Home", path: "/" },
  {
    name: "Certification",
    dropdown: [
      { name: "Halal Certification", path: "/certificates" },
      { name: "BPJPH Recognition", path: "/bpjph-recognition" },
    ],
  },
  { name: "About Us", path: "/about-us" },
  { name: "Our Principles", path: "/principes/principe" },
  { name: "Blog", path: "/blog" },
  { name: "FAQ", path: "/faq/faqs" },
  {
    name: "Contact Us",
    dropdown: [
      { name: "Apply", path: "/contact/apply" },
      { name: "Request Information", path: "/contact/request-info" },
      { name: "Feedback", path: "/contact/feedback" },
      { name: "Complaint", path: "/contact/complaint" },
      { name: "Halal Certificate Check", path: "/contact/certificate-check" },
      { name: "Saudi Arabia Export Approval", path: "/contact/saudi-export" },
    ],
  },
  { name: "Academy", path: "/academy", noLangPrefix: true },
];

function Navbar({ location }: { location: any }) {
  const { t, lang } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState<number | null>(null);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const handleDropdownEnter = (index: number) => {
    setDropdownOpen(index);
  };

  const handleDropdownLeave = () => {
    setDropdownOpen(null);
  };

  return (
    <>
      <nav className="top-0 z-20 fixed flex justify-between items-center w-full px-6 py-2 bg-white shadow-md">
        <Link className="flex items-center" to="/">
          <img src="/logo.png" alt="HSCC Logo" className="w-12 h-12 mr-2" />
          <span className="font-bold text-blue-600 text-xl">HSCC</span>
        </Link>

        <div className="hidden md:flex space-x-3 lg:space-x-6 text-xs lg:text-base">
          {LINKS.map((link, index) =>
            link.dropdown ? (
              <div
                key={index}
                className="relative"
                onMouseEnter={() => handleDropdownEnter(index)}
                onMouseLeave={handleDropdownLeave}
              >
                <span className="flex items-center font-semibold text-zinc-800 hover:text-blue-500 cursor-pointer">
                  {t(link.name)}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4 ml-1"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </span>
                {dropdownOpen === index && (
                  <div className="absolute w-40 pt-2 rounded-md bg-white shadow-lg">
                    {link.dropdown.map((subLink, subIndex) => (
                      <Link
                        key={subIndex}
                        to={subLink.noLangPrefix ? subLink.path! : `/${lang}${subLink.path}`}
                        className="block px-4 py-2 hover:bg-blue-100 text-zinc-800 text-sm"
                      >
                        {t(subLink.name)}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <Link
                key={index}
                // to={`/${lang}${link.path}`}
                to={link.noLangPrefix ? link.path! : `/${lang}${link.path}`}
                className={`font-semibold text-zinc-800 hover:text-blue-500 border-transparent border-b-2 hover:border-blue-500 transition`}
              >
                {t(link.name)}
              </Link>
            ),
          )}
        </div>

        <div className="flex gap-4">
          <Link
            to={`/${lang}/contact/apply`}
            className="px-4 py-2 rounded-lg bg-primary hover:bg-blue-600 shadow-md text-white transition-all"
          >
            Get Certified
          </Link>

          <button onClick={toggleMenu} className="md:hidden">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6 text-zinc-800"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7"></path>
            </svg>
          </button>
        </div>
      </nav>
      <MobileNavbar location={location} navItems={LINKS} open={menuOpen} toggleMenu={toggleMenu} lang={lang} />
    </>
  );
}

export default Navbar;
